import { useEffect, useRef } from 'react';
import { Card, Tag, Timeline, Typography } from 'antd';
import { useSimulation } from '../../context/SimulationContext';
import './TimelinePanel.scss';

function formatDimensionName(dim: string): string {
  return dim.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

function TimelinePanel() {
  const { timeline, turnIndex } = useSimulation();
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [timeline.length]);

  return (
    <Card title="Session History" className="timeline-panel" size="small">
      <div className="timeline-scroll">
        {timeline.length === 0 ? (
          <Typography.Text type="secondary">
            No turns yet. Submit your first action to begin.
          </Typography.Text>
        ) : (
          <Timeline>
            {timeline.map((entry) => (
              <Timeline.Item
                key={entry.turnIndex}
                color={entry.turnIndex === turnIndex ? 'blue' : 'gray'}
              >
                <div className="timeline-entry">
                  <Typography.Text strong>
                    Turn {entry.turnIndex + 1} &middot; Phase {entry.phase}
                  </Typography.Text>
                  <div className="timeline-actions">
                    {entry.actionsDetected.map((action) => (
                      <Tag key={action}>{action}</Tag>
                    ))}
                  </div>
                  {entry.reflectionProvided && (
                    <Typography.Text type="secondary">
                      Reflection provided
                    </Typography.Text>
                  )}
                  <div className="timeline-indicators">
                    {Object.entries(entry.indicatorSnapshot).map(
                      ([dim, band]) => (
                        <span
                          key={dim}
                          className={`indicator-dot indicator-${band}`}
                          title={`${formatDimensionName(dim)}: ${band}`}
                        />
                      ),
                    )}
                  </div>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        )}
        <div ref={bottomRef} />
      </div>
    </Card>
  );
}

export default TimelinePanel;
